module.exports = __webpack_public_path__ + "img/zeileloeschen.5f7fed2.svg";